import { render, staticRenderFns } from "./LiveConsult.vue?vue&type=template&id=360b17bf"
import script from "./LiveConsult.vue?vue&type=script&lang=js"
export * from "./LiveConsult.vue?vue&type=script&lang=js"
import style0 from "./LiveConsult.vue?vue&type=style&index=0&id=360b17bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1__ejs@3.1._d122e8da27108b932c0dfa09e6e9a5ee/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports